import { ProductPurchase } from '@/components/ProductPurchase/ProductPurchase'
import type { SbBaseBlockProps } from '@/services/storyblok/storyblok'

type ProductPurchaseBlockProps = SbBaseBlockProps<{
  products: Array<string>
  productByline?: string
  preSelectFirstProduct?: boolean
}>

export const ProductPurchaseBlock = ({ blok, nested }: ProductPurchaseBlockProps) => {
  return (
    <ProductPurchase
      products={blok.products}
      productByline={blok.productByline}
      preSelectFirstProduct={blok.preSelectFirstProduct}
      nested={nested}
    />
  )
}
